"use client";

import { AnimatePresence, motion } from "framer-motion";
import React, { Dispatch, FC, ReactNode, SetStateAction, createContext, useEffect, useState } from "react";

import CustomLoader from "@/components/ui/CustomLoader/CustomLoader";

// import Lottie from "react-lottie";

// import animationData from "../public/animations/dots.json";

interface LoadingProps {
  loading: Dispatch<SetStateAction<boolean>>;
  loadingValue: boolean;
}

export const LoadingContext = createContext<LoadingProps>({
  loading: () => {},
  loadingValue: false,
});
interface Props {
  children: ReactNode;
  loading?: boolean;
}
const LoadingProvider: FC<Props> = ({ children, loading = false }) => {
  // const defaultOptions = {
  //   loop: true,
  //   autoplay: true,
  //   animationData: animationData,
  //   rendererSettings: {
  //     preserveAspectRatio: "xMidYMid slice",
  //   },
  // };
  const [isLoading, setIsLoading] = useState<boolean>(loading);
  return (
    <LoadingContext.Provider value={{ loading: setIsLoading, loadingValue: isLoading }}>
      <>{children}</>
      <AnimatePresence>
        {isLoading && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
            className="fixed left-0 top-0 w-full h-full z-[100]  flex items-center justify-center"
          >
            <div>
              {/* <Lottie options={defaultOptions} width={100} /> */}
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                style={{ backgroundColor: "rgba(255,255,255,0.5)" }}
                className="fixed left-0 top-0 w-full h-full z-[100]  flex items-center justify-center rounded-xl"
              >
                <CustomLoader />
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </LoadingContext.Provider>
  );
};
export default LoadingProvider;
